export default __webpack_public_path__ + "static/media/pic_du_midi_contrast.f7d54f9c.jpg";